import React from "react";
import { useGetFloatRequestByIdQuery } from "../../../../api/employeeFloat";
import { useParams } from "react-router";
import PageLayout from "../../../Components/Layout/PageLayout";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
const ViewloatRequest = () => {
  const { id } = useParams();
  const { data } = useGetFloatRequestByIdQuery(id);
  const floatList = [
    {
      label: "Float Advance",
      value: 0,
    },
    {
      label: "Promotional Items",
      value: 1,
    },
    { label: "Perishables", value: 2 },
    {
      label: "Visitation",
      value: 3,
    },
  ];
  const actionButton = (
    <div>
      <CTAButtons>
        Action
      </CTAButtons>
    </div>
  );
  return (
    <PageLayout title={"Float Review Details"} hasBack={true} action={actionButton}>
      <div className={DashboardStyle.view_app_components}>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Process Information
          </h4>
          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Process Type:</p>
                {/* <h4>{request?.title}</h4> */}
              </div>
              <div>
                <p>Date Requested:</p>
                <h4>{FormatDateTime(data?.responseObject?.requestDate)}</h4>
              </div>
              <div>
                <p>Approval Status:</p>
                <h4>{data?.responseObject?.approvalResponse?.status}</h4>
              </div>
            </div>
            <div>
              <div>
                <p>Requested By:</p>
                <h4>{data?.responseObject?.requestorName}</h4>
              </div>
              {/* <div>
                      <p>Employee Group:</p>
                      <h4>{request?.employeeGroup?.title}</h4>
                    </div> */}
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Request Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Purpose:</p>
                <h4>{data?.responseObject?.purpose}</h4>
              </div>
              <div>
                <p>Reqest For:</p>
                <h4>{data?.responseObject?.requestFor}</h4>
              </div>
            </div>
            <div>
              <div>
                <p>Effective Days:</p>
                {/* <h4>{request?.employeeGroup?.title}</h4> */}
              </div>
              <div>
                <p>Number Of Days:</p>
                {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
              </div>
              <div></div>
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Float Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Float Type:</p>
                <h4>
                  {floatList
                    .filter((item) =>
                      data?.responseObject?.floatTypes?.includes(item.value)
                    )
                    .map((item) => `${item.label},`)}
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section
          // className={DashboardStyle.form_section}
          className="p-4 grid grid-cols-2 gap-4"
        >
          <div className="col-span-1">
            <h4 className={DashboardStyle.form_section_title}>
              Float Advance
            </h4>
          </div>

          <div className="w-full col-span-2">
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Sub-Category:</p>
                  <h4>{data?.responseObject?.floatAdvance?.subcategory}</h4>
                </div>
                <div>
                  <p>Total Amount:</p>
                  <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Budget:</p>
                  {/* <h4>{request?.employeeGroup?.title}</h4> */}
                </div>
                <div>
                  <p>Budget Status:</p>
                  {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                </div>

              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">
                Components
              </label>
              <table className="w-full border">
                <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                  <tr>
                    <th className="border p-2">S/N</th>
                    <th className="border p-2">Component</th>
                    <th className="border p-2">Optional</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.responseObject?.floatAdvance?.components
                    ?.map((item, index) => {
                      return (
                        <tr
                          className="text-[#4B664C] font-[500]"
                          key={index}
                        >
                          <td className="border p-2">{index + 1}</td>
                          <td className="border p-2">{item.componentName}</td>
                          <td className="border p-2">
                            {item.isCompulsory ? "Yes" : "No"}
                          </td>
                          <td className="border p-2">
                            <div className="border rounded flex items-center space-x-1 p-1 ">
                              <p>₦{item.amount}</p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

            </div>
          </div>

        </section>
        <section
          // className={DashboardStyle.form_section}
          className="p-4 grid grid-cols-2 gap-4"
        >
          <div className="col-span-1">
            <h4 className={DashboardStyle.form_section_title}>
              Promotional Item
            </h4>
          </div>

          <div className="w-full col-span-2">
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Item Category:</p>
                  <h4>{data?.responseObject?.promotionalItems?.itemCategory}</h4>
                </div>
                <div>
                  <p>Budget:</p>
                  <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Budget Status:</p>
                  {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                </div>
              </div>
            </div>
            <div>
              <table className="w-full border">
                <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                  <tr>
                    <th className="border p-2">S/N</th>
                    <th className="border p-2">Items</th>
                    <th className="border p-2">Stock Availability</th>
                    <th className="border p-2">Quantity Requested</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.responseObject?.promotionalItems?.items
                    ?.map((item, index) => {
                      return (
                        <tr
                          className="text-[#4B664C] font-[500]"
                          key={index}
                        >
                          <td className="border p-2">{index + 1}</td>
                          <td className="border p-2">{item.itemName}</td>
                          <td className="border p-2">
                            {item.availableStock}
                          </td>
                          <td className="border p-2">
                            {item.quantity}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

            </div>
          </div>

        </section>
      </div>
    </PageLayout>
  );
};

export default ViewloatRequest;
